module.exports = __webpack_public_path__ + "static/media/HAUX_TRAINING_GUIAS_POTENCIA.4c50d379.pdf";